import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IIremboOrganizationResponse } from '../models/irembo-organization.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdministrationService {
  private adminBaseUrl = environment.apiGatewayBaseUrl + '/admin';

  constructor(private http: HttpClient) {}

  getOrganizationById(organizationId: string) {
    const url = `${this.adminBaseUrl}/v1/organizations/${organizationId}`;
    return this.http.get<IIremboOrganizationResponse>(url, {});
  }

  getOrganizationLogo(imageName: string): Observable<Blob> {
    const url = `${this.adminBaseUrl}/v1/file-manager?fileName=${imageName}`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
